// Configuration for Periodontics Table rows, should be similar to the WEB one

export type TableRowConfig = {
  rowIndex: number
  key: string // Unique key for this row (e.g., "furcation", "cal")
  title: string
  fieldCount: number // Number of input fields per main column (3 for most, 1 for tooth)
  isBooleanRow?: boolean // If true, show checkboxes instead of text inputs (for BOP rows)
}

export type TableGroupConfig = {
  groupKey?: string // Unique key for this group (e.g., "vestibular", "lingual")
  groupTitle?: string
  rows: TableRowConfig[]
}

// 10 main columns (admin can leave some empty)
export const MAIN_COLUMN_COUNT = 10

export const PERIODONTICS_TABLE_GROUPS: TableGroupConfig[] = [
  {
    groupKey: 'vestibular',
    groupTitle: 'Vestibular',
    rows: [
      { rowIndex: 0, key: 'furcation', title: 'Furcation', fieldCount: 3 },
      { rowIndex: 1, key: 'cal', title: 'CAL', fieldCount: 3 },
      { rowIndex: 2, key: 'recession', title: 'Recession', fieldCount: 3 },
      { rowIndex: 3, key: 'bop', title: 'BOP', fieldCount: 3, isBooleanRow: true },
      { rowIndex: 4, key: 'probing', title: 'Probing', fieldCount: 3 },
    ],
  },
  {
    rows: [{ rowIndex: 5, key: 'tooth', title: 'Tooth', fieldCount: 1 }],
  },
  {
    groupKey: 'lingual',
    groupTitle: 'Lingual',
    rows: [
      { rowIndex: 6, key: 'bop', title: 'BOP', fieldCount: 3, isBooleanRow: true },
      { rowIndex: 7, key: 'probing', title: 'Probing', fieldCount: 3 },
      { rowIndex: 8, key: 'recession', title: 'Recession', fieldCount: 3 },
      { rowIndex: 9, key: 'cal', title: 'CAL', fieldCount: 3 },
      { rowIndex: 10, key: 'furcation', title: 'Furcation', fieldCount: 3 },
    ],
  },
  {
    rows: [{ rowIndex: 11, key: 'mobility', title: 'Mobility', fieldCount: 3 }],
  },
]

// Helper to generate cell key: "{groupKey}_{rowKey}_{columnIndex}_{cellIndex}" or "{rowKey}_{columnIndex}_{cellIndex}"
export const getCellKey = (
  groupKey: string | undefined,
  rowKey: string,
  columnIndex: number,
  cellIndex: number
): string => {
  if (groupKey) {
    return `${groupKey}_${rowKey}_${columnIndex}_${cellIndex}`
  }
  return `${rowKey}_${columnIndex}_${cellIndex}`
}

// Helper to get all cell keys for a row
export const getRowCellKeys = (groupKey: string | undefined, rowKey: string, fieldCount: number): string[] => {
  const keys: string[] = []
  for (let columnIndex = 0; columnIndex < MAIN_COLUMN_COUNT; columnIndex++) {
    for (let cellIndex = 0; cellIndex < fieldCount; cellIndex++) {
      keys.push(getCellKey(groupKey, rowKey, columnIndex, cellIndex))
    }
  }
  return keys
}

export const MIN_TABLE_WIDTH = 2400 // px
